import React, { useState } from 'react';
import './FeatureCards.css';

interface Feature {
  id: string;
  title: string;
  subtitle: string;
  image: string;
}

interface FeatureCardsProps {
  features: Feature[];
  isReversed?: boolean; // 控制左右布局
  title?: string;
  description?: string;
}

const FeatureCards: React.FC<FeatureCardsProps> = ({
  features,
  isReversed = false,
  title,
  description,
}) => {
  const [activeFeature, setActiveFeature] = useState<string>(features[0]?.id || '');

  const handleFeatureClick = (featureId: string) => {
    setActiveFeature(featureId);
  };

  const activeFeatureData = features.find(feature => feature.id === activeFeature);

  return (
    <section className="feature-cards-section">
      {(title || description) && (
        <div className="container mx-auto px-4 mb-12 text-center">
          {title && <h1 className="text-[60px] font-bold text-black mb-4">{title}</h1>}
          {description && <p className="text-lg text-gray-600">{description}</p>}
        </div>
      )}

      <div className="container mx-auto px-4 mb-12 text-center">
        <div className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 items-center justify-center`}>
          {/* 功能标题列表 */}
          <div className="feature-tabs w-full lg:w-2/5 flex flex-col justify-center">
             <div className="feature-tabs-container max-w-md lg:ml-0 lg:mr-auto text-left">
               {features.map((feature) => (
                 <div
                   key={feature.id}
                   className={`feature-tab p-4 mb-2 rounded-lg cursor-pointer transition-all ${
                     activeFeature === feature.id ? 'active-tab' : 'inactive-tab'
                   }`}
                   onClick={() => handleFeatureClick(feature.id)}
                 >
                   <h3 className={`text-xl font-semibold mb-6 ${activeFeature === feature.id ? 'text-black' : 'text-gray-500'}`}>{feature.title}</h3>
                   {activeFeature === feature.id && (
                     <p className="text-primary/70 text-lg font-medium">{feature.subtitle}</p>
                   )}
                 </div>
               ))}
             </div>
           </div>

          {/* 功能图片展示 */}
          <div className="lg:w-1/2 relative w-full max-w-md mx-auto flex justify-center items-center">
  {activeFeatureData && (
                <img
                  src={activeFeatureData.image}
                  alt={activeFeatureData.title}
                  className="phone-mockup relative z-10 rounded-2xl overflow-hidden bg-background ml-0 lg:ml-8"
                />
              )}  
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;